module.exports = __webpack_public_path__ + "media/images/logo-white-448x112-c0de8dc98ebea047c2759b305d8d4884.png";